import Util from "@/Master/Util";
import {MainState, setMainState} from "@/app/MainSlice";

export const UpdateMainState = async (tag:string,updateData: Partial<MainState>)=> {
    if (Util.isLog){
        console.log("UpdateMainState", tag, updateData)
    }
    if (!Util.isWindow) return; // 跳过服务端执行
    const { store } = await import('@/app/store');
    store.dispatch(setMainState(updateData));
}

export const getMainState = async ()=>{
    if (!Util.isWindow){
        return {isDBok: false} as MainState;
    } // 跳过服务端执行
    const { store } = await import('@/app/store');
    return store.getState().mainState;
}


